import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-settings-layout',
    templateUrl: './settings-layout.component.html',
    styleUrls: ['./settings-layout.component.scss'],
    standalone: false
})
export class SettingsLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
